var _slicedToArray = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray.js").default;

var _classCallCheck = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass.js").default;

var _possibleConstructorReturn = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js").default;

var _inherits = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits.js").default;

var _get = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get.js").default;

var _getPrototypeOf = require("/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf.js").default;

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

var $625ad1e1f4c43bc1$exports = require("./CalendarDate.main.js");

var $af14c9812fdceb33$exports = require("./GregorianCalendar.main.js");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

$parcel$export(module.exports, "BuddhistCalendar", function () {
  return $561c4ef058278b74$export$42d20a78301dee44;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
// Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.

var $561c4ef058278b74$var$BUDDHIST_ERA_START = -543;

var $561c4ef058278b74$export$42d20a78301dee44 = /*#__PURE__*/function (_ref) {
  "use strict";

  function $561c4ef058278b74$export$42d20a78301dee44() {
    var _this2;

    _classCallCheck(this, $561c4ef058278b74$export$42d20a78301dee44);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _callSuper(this, $561c4ef058278b74$export$42d20a78301dee44, [].concat(args)), _this2.identifier = 'buddhist';
    return _this2;
  }

  _inherits($561c4ef058278b74$export$42d20a78301dee44, _ref);

  return _createClass($561c4ef058278b74$export$42d20a78301dee44, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var gregorianDate = _get(_getPrototypeOf($561c4ef058278b74$export$42d20a78301dee44.prototype), "fromJulianDay", this).call(this, jd);

      var year = (0, $af14c9812fdceb33$exports.getExtendedYear)(gregorianDate.era, gregorianDate.year);
      return new (0, $625ad1e1f4c43bc1$exports.CalendarDate)(this, year - $561c4ef058278b74$var$BUDDHIST_ERA_START, gregorianDate.month, gregorianDate.day);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return _get(_getPrototypeOf($561c4ef058278b74$export$42d20a78301dee44.prototype), "toJulianDay", this).call(this, $561c4ef058278b74$var$toGregorian(date));
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['BE'];
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      return _get(_getPrototypeOf($561c4ef058278b74$export$42d20a78301dee44.prototype), "getDaysInMonth", this).call(this, $561c4ef058278b74$var$toGregorian(date));
    }
  }, {
    key: "balanceDate",
    value: function balanceDate() {}
  }]);
}((0, $af14c9812fdceb33$exports.GregorianCalendar));

function $561c4ef058278b74$var$toGregorian(date) {
  var _ref2 = (0, $af14c9812fdceb33$exports.fromExtendedYear)(date.year + $561c4ef058278b74$var$BUDDHIST_ERA_START),
      _ref3 = _slicedToArray(_ref2, 2),
      era = _ref3[0],
      year = _ref3[1];

  return new (0, $625ad1e1f4c43bc1$exports.CalendarDate)(era, year, date.month, date.day);
}